<h4>Image Widget Settings</h4>

<mat-tab-group>
  <mat-tab label="Appearance">
    <div>
    <mat-form-field>
      <mat-label>Title Label</mat-label>
      <input matInput [(ngModel)]="widget.title" name="widget.title">
    </mat-form-field>
    </div>

    <widget-background-colour [widget]="widget"></widget-background-colour>
  </mat-tab>

  <mat-tab label="Data">
    <mat-form-field>
      <mat-label>Image URL</mat-label>
      <input matInput required urlValidator [(ngModel)]="widget.imageSrc" name="imageSrc" #imageSrc="ngModel">
    </mat-form-field>
    <div *ngIf="imageSrc.invalid && (imageSrc.dirty || imageSrc.touched)"
         class="alert">

      <div *ngIf="imageSrc.errors?.['required']">
        URL is required.
      </div>

      <div *ngIf="imageSrc.errors?.['urlValidator'] && !imageSrc.errors?.['required']">
        Invalid URL.
      </div>
    </div>

  </mat-tab>

  <mat-tab label="Interactivity"> Interactivity </mat-tab>

  <mat-tab label="Alerts"> Alerts </mat-tab>
</mat-tab-group>


<!--<mat-tab-group>
  <mat-tab label="Appearance">
    <widget-background-colour [widget]="widget"></widget-background-colour>
  </mat-tab>

  <mat-tab label="Data"> Data </mat-tab>

  <mat-tab label="Interactivity"> Interactivity </mat-tab>

  <mat-tab label="Alerts"> Alerts </mat-tab>
</mat-tab-group>-->
